import React from 'react';
import Markdown from 'react-markdown';
import Button from '../Button/Button';
import './style.scss';
import { getImageUrl, getVideoSources } from '../../utils/helpers';

export const mapHeroProps = (hero) => ({
  backgroundType: hero?.background?.mime.startsWith('video') ? 'VIDEO' : 'IMAGE',
  backgroundHash: hero.background?.hash,
  primaryText: hero?.title || '',
  secondaryText: hero?.subtitle || '',
  ctaLink: hero.ctaLink,
  ctaText: hero.ctaText,
});

export const createHero = (title, subtitle, background) => ({
  backgroundType: background?.mime.startsWith('video') ? 'VIDEO' : 'IMAGE',
  backgroundHash: background?.hash,
  primaryText: `# ${title}` || '',
  secondaryText: subtitle || '',
  ctaLink: '/about-us',
  ctaText: 'Read more',
});

function Hero({ data }) {
  const hero = mapHeroProps(data);
  return (
    <section className='hero__container'>
      {hero.backgroundType === 'VIDEO' && (
        <video
          width='100%'
          controls={false}
          autoPlay
          playsInline
          muted
          loop
          className='hero__bg'
        >
          {getVideoSources(hero.backgroundHash, 'e_brightness:-20')}
        </video>
      )}
      {hero.backgroundType === 'IMAGE' && (
        <img
          src={getImageUrl(hero.backgroundHash, 'co_rgb:052A2D,e_colorize:50')}
          className='hero__bg'
        />
      )}
      <div className='hero__content pt-64 lg:pt-0 container'>
        <Markdown>{hero.primaryText}</Markdown>
        <p className='whitespace-pre-line'>{hero.secondaryText}</p>
        {hero.ctaLink && (
          <Button
            link={hero.ctaLink}
            text={hero.ctaText}
          />
        )}
      </div>
    </section>
  );
}

export default Hero;
